import React from 'react';
import FullPageMessage from '../../../common/fullPageMessage/FullPageMessage';
import {
	ONBOARDING_ERROR_BLOCKED_OPEN_PAYMENT_TITLE,
	ONBOARDING_ERROR_BLOCKED_OPEN_PAYMENT_DESCRIPTION,
	ONBOARDING_ERROR_BLOCKED_OPEN_PAYMENT_LINK_TEXT,
	ONBOARDING_ERROR_BLOCKED_OPEN_PAYMENT_LINK,
} from '../../../../constants/Copy';
import Message from '../../../common/message/Message';
import { UserStatusLoggedIn } from '../../../user-status/UserStatusLoggedIn';
import './BlockedOpenPayment.scss';

const BlockedOpenPayment = () => {
	return (
		<section className="blocked-open-payment">
			<FullPageMessage
				title={ONBOARDING_ERROR_BLOCKED_OPEN_PAYMENT_TITLE}
				description={
					<Message
						message={ONBOARDING_ERROR_BLOCKED_OPEN_PAYMENT_DESCRIPTION}
						values={{
							link: (
								<a
									className="onboarding__link"
									target="_blank"
									href={ONBOARDING_ERROR_BLOCKED_OPEN_PAYMENT_LINK}
									rel="noopener"
								>
									{ONBOARDING_ERROR_BLOCKED_OPEN_PAYMENT_LINK_TEXT}
								</a>
							),
						}}
					/>
				}
			/>
			<UserStatusLoggedIn />
		</section>
	);
};

export default BlockedOpenPayment;
